<template lang="pug">
    div.panel-dashboard(:class="{'panel-dashboard--closed': !isOpened}")
      div.panel-dashboard__content
        slot(name="title")
        slot(name="menu")
        slot(name="header-container")
        slot(name="container")
      button(type="button" @click="openDash()").panel-dashboard__button
        ods-icon(name="double-right" size="22")
      slot(name="tools")
      slot(name="search")
</template>

<script>
export default {
  name: 'PanelDashboard',
  data () {
    return {
      isOpened: true
    }
  },
  props: { },

  methods: {
    openDash () {
      this.isOpened = !this.isOpened
      // this.$root.$emit('viewerdashboard-clicked')
    },
    collapsePanel (val) {
      this.isOpened = val
    }
  }
}
</script>

<style scoped lang="scss">

  .panel-dashboard {
    background-color: $--color-white;
    // box-shadow: -10px 0 18px rgba(0, 0, 0, 0.01);
    // box-shadow: 0px 0px 10px 0px #0000002e;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    height: 100%;
    //height: calc(100% - 72px);
    position: absolute;
    right: 0;
    top: 0;
    transform: translate3d(0, 0, 0);
    transition: transform .4s ease;
    width: 30%;
    z-index: 20;

    &__content {
      box-sizing: border-box;
      display: block;
      height: 100%;
      opacity: 1;
      position: relative;
      transition: opacity .4s .25s;
      width: 100%;
    }

    &__button {
      background-color: $--color-white;
      border-radius: 36px;
      border: 1px solid $--color-primary;
      box-shadow: 0 2px 3px 0 rgba(204, 204, 204, 0.3);
      cursor: pointer;
      display: block;
      height: 36px;
      left: -26px;
      margin: 0;
      outline: none;
      padding: 0;
      pointer-events: initial;
      position: absolute;
      top: 50%;
      width: 36px;
      z-index: 9999;
      .ods-icon-double-right {
        color: $--color-primary;
        left: 0;
        line-height: inherit;
        position: relative;
        transform: rotate(0deg);
        transition: transform 0.75s ease;
      }
    }
    &__tools {
      display: block;
      margin: 0;
      outline: none;
      padding: 0 rem(16) rem(16) 0;
      position: absolute;
      &--bottom-left-out {
        bottom: 0;
        right: 100%;
      }
    }
    &__search {
      display: block;
      margin: 0;
      outline: none;
      padding: 0 rem(16) rem(16) 0;
      position: absolute;
      &--top-left-out {
        top: 75px;
        right: 100%;
      }
    }

    &--closed {
      transform: translate3d(calc(100% - 30px), 0, 0);
      transition: transform .4s ease;
      pointer-events: none;
      .panel-dashboard__content {
        opacity: 0;
        transition: opacity .4s;
      }
      .ods-icon-double-right {
        transform: rotate(-180deg);
        transition: transform .4s ease;
      }
    }
  }

// QUERYS
@media only screen and (min-width: 1920px){
  .panel-dashboard {
    max-width: rem(500);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PanelDashboard.vue